import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  fonts: { brandonGrotesqueRegular },
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, linkButtonText },
} = mixins;

export const PageSection = styled.section`
  ${pageSection}
  color: ${(props) => props.fontColor ? color(props.fontColor) : color(`white`)};

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}
  /* stylelint-enable */

  &:after {
    clear: both;
  }
`;

export const Container = styled.div`
  ${pageSectionInner}
  width: 100%;
  margin-right: auto;
  margin-left: auto;
`;

export const ContentContainer = styled.div`
  
`;

export const Quote = styled.p`
  ${heading1}
  ${brandonGrotesqueRegular}
  color: ${color(`black`)};
  text-align: center;
`;

export const Footnote = styled.h3`
  ${heading2}
  color: ${color(`gray`)};
  text-align: center;
  text-transform: uppercase;
`;